package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.*
import com.exura.pages.planCreator.components.seriesViews.inputs.ModeOption
import com.exura.pages.planCreator.components.seriesViews.inputs.ModeSelectorInput
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorIntegerInput
import com.exura.ui.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

enum class FrequencyMode {
    SINGLE,
    DAILY,
    EVERY_X_DAYS;
}

fun frequencyModeOption(
    mode: FrequencyMode,
    spawnEveryDays: Int,
    inputMode: PlanCreatorInputMode,
    onSpawnEveryDaysChange: (Int) -> Unit,
    onModeChange: (FrequencyMode) -> Unit = {},
): ModeOption<FrequencyMode> = when (mode) {
    FrequencyMode.SINGLE -> ModeOption(
        onClick = {
//            onSpawnEveryDaysChange(1) // Set to 1 for single execution
            onModeChange(FrequencyMode.SINGLE)
        }
    ) {
        SpanText("Raz")
    }
    FrequencyMode.DAILY -> ModeOption(
        onClick = {
            onSpawnEveryDaysChange(1)
            onModeChange(FrequencyMode.DAILY)
        }
    ) {
        SpanText("Codziennie")
    }
    FrequencyMode.EVERY_X_DAYS -> ModeOption(
        onClick = {
            if (spawnEveryDays == 1) onSpawnEveryDaysChange(2)
            onModeChange(FrequencyMode.EVERY_X_DAYS)
        }
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(12.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText("Co")
            PlanCreatorIntegerInput(
                value = spawnEveryDays.coerceAtLeast(2),
                onValueChange = onSpawnEveryDaysChange,
                mode = inputMode,
                textStyle = TextStyles.medium16,
                minValue = 2
            )
            SpanText(if (spawnEveryDays == 1) "dzień" else "dni")
        }
    }
}

@Composable
internal fun SpawnEveryDaysSection(
    selectedValue: FrequencyMode,
    spawnEveryDays: Int,
    onSpawnEveryDaysChange: (Int) -> Unit,
    onModeChange: (FrequencyMode) -> Unit = {},
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
) = EditViewSection(
    enabled = enabled,
    title = "Jak często?",
    withTitle = false,
) {
    ModeSelectorInput(
        options = listOf(FrequencyMode.SINGLE, FrequencyMode.DAILY, FrequencyMode.EVERY_X_DAYS),
        optionToMode = { frequencyMode ->
            frequencyModeOption(
                mode = frequencyMode,
                spawnEveryDays = spawnEveryDays,
                inputMode = mode,
                onSpawnEveryDaysChange = onSpawnEveryDaysChange,
                onModeChange = onModeChange,
            )
        },
        selectedValue = selectedValue,
        mode = mode,
        enabled = enabled,
    )
}
